import quoteGQLString from '../util/quoteGQLString';

export default (id) => `
    inactivateOrg (org: ${quoteGQLString(id)})
`;
